import { applyAnimationsToObject } from '../../components/layout/gridpage/AppLeftSection/utils/animationFunctions';

/**
 * Starts all active timeline animations on the scene (same behavior as AppLeftSection startAllAnimations).
 */
export function startAllSceneAnimations(scene, animationObjects, activeAnimationsRef) {
  if (!scene || !animationObjects?.length) return;

  activeAnimationsRef.current.forEach((animationIdRef) => {
    if (animationIdRef.current) {
      cancelAnimationFrame(animationIdRef.current);
    }
  });
  activeAnimationsRef.current.clear();

  for (let i = 0; i < animationObjects.length; i++) {
    const animObj = animationObjects[i];

    if (animObj.isActive === false) {
      continue;
    }

    const animationObject = scene.getObjectByName(animObj.id);
    if (!animationObject) {
      continue;
    }

    let animations = animObj.timelineEffects;
    if (!animations || animations.length === 0) {
      if (animObj.startTime !== undefined && animObj.endTime !== undefined) {
        animations = [
          {
            ...animObj,
            startTime: animObj.startTime,
            endTime: animObj.endTime,
            effectType: animObj.effectType || 'move',
            easing: animObj.easing || 'None',
            activeAxes: animObj.activeAxes || { x: true, y: false, z: false },
            startPosition: animObj.startPosition || { x: 0, y: 0, z: 0 },
            endPosition: animObj.endPosition || { x: 10, y: 0, z: 0 },
          },
        ];
      }
    }

    if (animations && animations.length > 0) {
      const animationIdRef = { current: null };
      applyAnimationsToObject(animationObject, animations, animationIdRef);
      activeAnimationsRef.current.set(animObj.id, animationIdRef);
    }
  }
}
